export default __webpack_public_path__ + "media/icons/telegram-a165cb9f.svg";